import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FAQRoutingModule } from './faq-routing.module';
import { FAQComponent } from './faq.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HgCommonModule } from '../hg-common/hg-common.module';
import { SupportAndLearnComponent } from './support-and-learn/support-and-learn.component';


@NgModule({
  imports: [
    CommonModule,
    FAQRoutingModule,
    HgCommonModule
  ],
  declarations: [FAQComponent, HeaderComponent, FooterComponent, SupportAndLearnComponent]
})
export class FAQModule { }